// src/components/DistrictProblems.js
import React, { useMemo } from 'react';
import { 
  calculatePublicationProblems,
  hasTimelinessProblems,
  getSchoolNumber,
  isDateOutdatedTmRk,
  isDateOutdatedcp,
  THRESHOLDS
} from '../utils/calculations';

const DistrictProblems = ({ districtData, filters }) => {
  return (
    <div className="problems-grid">
      <ProblemCard 
        title="Типовое меню"
        data={districtData}
        type="tm"
      />
      <ProblemCard 
        title="Календарь питания"
        data={districtData}
        type="kp"
      />
      <ProblemCard 
        title="Родительский контроль"
        data={districtData}
        type="rk"
      />
      <ProblemCard 
        title="Ошибки в меню"
        data={districtData}
        type="errors"
      />
      <ProblemCard 
        title="Соответствие меню"
        data={districtData}
        type="compliance"
      />
      <ProblemCard 
        title="Публикация меню"
        data={districtData}
        type="publication"
        filters={filters}
      />
      <ProblemCard 
        title="Своевременность"
        data={districtData}
        type="timeliness"
        filters={filters}
      />
    </div>
  );
};

const ProblemCard = ({ title, data, type, filters }) => {
  const { schools, count } = useMemo(() => {
    let schoolsWithProblems = [];
    
    switch (type) {
      case 'tm':
        schoolsWithProblems = data.dates.filter(school => isDateOutdatedTmRk(school.ДатаТМ));
        break;
      case 'kp':
        schoolsWithProblems = data.dates.filter(school => isDateOutdatedcp(school.ДатаКП));
        break;
      case 'rk':
        schoolsWithProblems = data.dates.filter(school => isDateOutdatedTmRk(school.ДатаРК));
        break;
      case 'errors':
        schoolsWithProblems = data.dates.filter(school => 
          data.errors.some(error => error.Пищеблок.includes(school.Наименование))
        );
        break;
      case 'compliance':
        schoolsWithProblems = data.dates.filter(school => {
          const schoolCompliance = data.compliance.filter(item => 
            item.ПищеблокНаименование.includes(school.Наименование)
          );
          const avgCompliance = schoolCompliance.length > 0 ? 
            schoolCompliance.reduce((sum, item) => sum + item.ПроцентСоблюдения, 0) / schoolCompliance.length : 100;
          return avgCompliance < THRESHOLDS.COMPLIANCE_SCHOOL_TABLE;
        });
        break;
      case 'publication':
        schoolsWithProblems = calculatePublicationProblems(data, filters.month, filters.year).filter(school => 
          data.dates.some(ds => ds.Код === school.Код)
        );
        break;
      case 'timeliness':
        schoolsWithProblems = data.dates.filter(school => 
          hasTimelinessProblems(school, data.timeliness, THRESHOLDS.TIMELINESS_GOOD)
        );
        break;
      default:
        schoolsWithProblems = [];
    }

    const schoolNumbers = schoolsWithProblems.map(school => getSchoolNumber(school.Наименование));
    
    return {
      schools: schoolNumbers,
      count: schoolsWithProblems.length
    };
  }, [data, type, filters]);

  if (count === 0) {
    return (
      <div className="card compact-card">
        <h3>{title}</h3>
        <p className="success compact-summary">Нет проблем</p>
      </div>
    );
  }

  return (
    <div className="card compact-card">
      <h3>{title}</h3>
      <p className="error compact-summary">{count} ОУ</p>
      <div className="school-numbers">
        {schools.map((number, index) => (
          <span key={index} className="school-number">{number}</span>
        ))}
      </div>
    </div>
  );
};

export default DistrictProblems;